"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignsFilters = exports.CampaignMode = void 0;
var CampaignMode;
(function (CampaignMode) {
    CampaignMode["Active"] = "ACTIVE";
    CampaignMode["Archive"] = "ARCHIVE";
    CampaignMode["Deleted"] = "DELETED";
})(CampaignMode = exports.CampaignMode || (exports.CampaignMode = {}));
var CampaignsFilters;
(function (CampaignsFilters) {
    CampaignsFilters["CampaignsCreatedByMe"] = "campaigns_created_by_me";
    CampaignsFilters["CampaignsFavourites"] = "campaigns_favourites";
})(CampaignsFilters = exports.CampaignsFilters || (exports.CampaignsFilters = {}));
//# sourceMappingURL=campaignMode.enum.js.map